/**
  * Medienunterstützung für Grafik-, Audio- und Video-Elemente
  * @namespace v3sWbtPlayerApp:page:media
  */

/**
 * Verwaltet und steuert die Medien
 * @class service_v3sMediaService
 * @memberOf v3sWbtPlayerApp:page:media
 */
angular.module('v3sWbtPlayerApp').factory('v3sMediaService', ["v3sContentMediaPath", "$q", "$timeout", "$interval", "v3sServiceFinder", "v3sBrowserInfoService", "v3sLog", function (v3sContentMediaPath, $q, $timeout, $interval, v3sServiceFinder, v3sBrowserInfoService, v3sLog) {
    var v3sSubtitleService = v3sServiceFinder.get("v3sSubtitleService");
    var v3sWbtSettingsService = v3sServiceFinder.get("v3sWbtSettingsService");

    var mediaObjects = {};
    var currentMedia = null;
    var isMuted = false;
    var showSubtitles = false;
    var playbackStatus = null;

    /**
     * Unterstützte Medienformate
     */
    var formatType = new Array();
    formatType['mp4'] = "video/mp4";
    formatType['webm'] = "video/webm";
    formatType['ogv'] = "video/ogg";
    formatType['m4a'] = "audio/x-m4a";
    formatType['ogg'] = "audio/ogg";
    formatType['mp3'] = "audio/mpeg";
    formatType['wav'] = "audio/x-wav";

    if (v3sWbtSettingsService) {
        v3sWbtSettingsService.subscribeSettingsChanged(null, function () {
            mute(v3sWbtSettingsService.get("muteAudio"));
            showSubtitle(v3sWbtSettingsService.get("showSubtitle"));
        });
    }

    var ready = true;
    var deferPrepareMedia = null;
    var oneMediaObjectMode = v3sBrowserInfoService.isBrowserWithoutAutoplay(); // ADAC-Video-Bug 19847, alle andere Browser sollen in oneMediaObjectMode Medien abspielen

    var singleAudio = null,
        singleAudioSrc = null;
    function cteateAudioObject() {
        singleAudio = angular.element(document.createElement("audio"));
        singleAudioSrc = angular.element(document.createElement("source"));
        singleAudioSrc[0].setAttribute("src", "");
        singleAudioSrc[0].setAttribute("type", "");
        singleAudio.append(singleAudioSrc);
    }

    var singleVideo = null,
        singleVideoSrc = null;
    function cteateVideoObject() {
        singleVideo = angular.element(document.createElement("video"));
        singleVideoSrc = angular.element(document.createElement("source"));
        singleVideoSrc[0].setAttribute("src", "");
        singleVideoSrc[0].setAttribute("type", "");
        singleVideo.append(singleVideoSrc);
    }

    function cteateMediaObjects() {
        if (singleAudio == null) cteateAudioObject();
        if (singleVideo == null) cteateVideoObject();
    }

    /**
     * Bereitet das Abspielen der Medien bei Benutzerinteraktion
     * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService
     * @return promise
     */
    function prepareMedia() {
        if (!deferPrepareMedia)
            deferPrepareMedia = $q.defer();

        if (ready)
            deferPrepareMedia.resolve(ready);

        return deferPrepareMedia.promise;
    }

    function enableAutoplay() {
        if (!deferPrepareMedia)
            deferPrepareMedia = $q.defer();

        if (ready) {
            deferPrepareMedia.resolve(ready);
        } else {
            //Play Button anzeigen
            var playBtn = angular.element('<v3s-timeline-play-on-mobile></v3s-timeline-play-on-mobile>');
            var wbtView = angular.element(document.querySelector("#popups"));

            playBtn.bind("mousedown", function (event) {
                try {
                    cteateMediaObjects();

                    singleVideo[0].load();
                    singleVideo[0].play();

                    singleAudio[0].load();
                    singleAudio[0].play();

                    ready = true;
                    v3sLog.info("Autoplay is enabled now.");
                } catch (e) {
                    v3sLog.warn("Exception! Autoplay is not available.", false, e);
                    deferPrepareMedia.reject();
                }

                playBtn.remove();

                $timeout(function () {
                    deferPrepareMedia.resolve(ready);
                }, 300);
            });

            wbtView.append(playBtn);
        }

    }

    /**
     * Überprüft das Abspielen der Medien
     * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService
     * @return true, falls MediaService bereit ist
     */
    function checkAutoplay() {
        ready = false;

        cteateMediaObjects();
        singleAudioSrc[0].type = "audio/mpeg";
        singleAudioSrc[0].src = "data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU2LjM2LjEwMAAAAAAAAAAAAAAA//OEAAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAAEAAABIADAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV6urq6urq6urq6urq6urq6urq6urq6urq6v////////////////////////////////8AAAAATGF2YzU2LjQxAAAAAAAAAAAAAAAAJAAAAAAAAAAAASDs90hvAAAAAAAAAAAAAAAAAAAA//MUZAAAAAGkAAAAAAAAA0gAAAAATEFN//MUZAMAAAGkAAAAAAAAA0gAAAAARTMu//MUZAYAAAGkAAAAAAAAA0gAAAAAOTku//MUZAkAAAGkAAAAAAAAA0gAAAAANVVV";

        var promise = singleAudio[0].play();
        if (promise !== undefined) {
            promise.then(function () {
                ready = true;
                v3sLog.info("Autoplay is enabled (without a user interaction).");
                enableAutoplay();
            })["catch"](function (error) {
                v3sLog.warn("Autoplay was prevented. Waiting for a user interaction...", false, error);
                enableAutoplay();
            });
        } else {
            v3sLog.warn("Autoplay check is not possible. Waiting for a user interaction...");
            enableAutoplay();
        }
    }

    if (oneMediaObjectMode) {
        checkAutoplay();
    } else {
        v3sLog.info("Autoplay is enabled (multi media object mode is on).");
    }

    /**
     * Gibt die Bereitschaft zum Abspielen der Medien zurück
     * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService
     * @return true, falls MediaService bereit ist
     */
    function isMediaServiceReady() {
        return ready;
    }

    /**
     * Gibt einen passenden Medientyp zurück
     * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService
     * @param file - Dateipfad
     * @return Medientyp
     */
    function getMediaType(file) {
        var fileExtension = file.substr(file.lastIndexOf('.') + 1);
        var type = "";
        if (!!formatType[fileExtension]) {
            type = formatType[fileExtension];
        }
        return type;
    }

    /**
     * Erstellt ein Medienobjekt (Audio/Video)
     * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService
     * @param obj - Medien-Objekt mit DOM-Element, Dateipfad und Untertitel
     * @return Medienobjekt
     */
    function createMedia(obj) {
        var media = new Media(obj);
        if (!!mediaObjects[media.id] && !!mediaObjects[media.id].promise) {
            mediaObjects[media.id].resolve(media);
        }

        mediaObjects[media.id] = media;
        return media;
    }

    /**
     * Gibt ein Medienobjekt zurück
     * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService
     * @param id - Medien-Id
     * @return eine Promise, die aufgelöst wird, wenn Medienobjekt geladen ist.
     */
    function getMedia(id) {
        var deferredInited;

        if (!!id && !!mediaObjects[id] && !!mediaObjects[id].promise) {
            deferredInited = mediaObjects[id];
        } else {
            deferredInited = $q.defer();

            if (!!id) {
                if (!!mediaObjects[id]) {
                    deferredInited.resolve(mediaObjects[id]);
                } else {
                    mediaObjects[id] = deferredInited;
                }
            } else {
                deferredInited.reject();
            }
        }

        return deferredInited.promise;
    }

    /**
     * Gibt aktives Medienobjekt zurück
     * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService
     * @return aktives Medienobjekt
     */
    function getCurrentMedia() {
        return currentMedia;
    }

    /**
     * Muted/Unmuted das Aktuelle Medium
     * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService
     * @param state - Mute oder Unmute des Audios
     */
    function mute(state) {
        var currentMedia = getCurrentMedia();
        isMuted = !!state;
        if (!!currentMedia) {
            currentMedia.media[0].muted = isMuted;
        }
    }

    /**
     * Zeigt oder versteckt die Untertitle
     * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService
     * @param state - Untertitle zeigen oder verstecken
     */
    function showSubtitle(state) {
        var currentMedia = getCurrentMedia();
        showSubtitles = !!state;
        if (v3sSubtitleService) {
            if (showSubtitles) {
                if (currentMedia) {
                    v3sSubtitleService.show(currentMedia.subtitle, currentMedia, true);
                } else {
                    v3sSubtitleService.showContainer();
                }
            } else {
                v3sSubtitleService.hideContainer();
            }
        }
    }
    /**
     * Löscht alle Medienobjekte
     * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService
     */
    function destroy() {
        angular.forEach(mediaObjects, function (media, id) {
            if (!!media && !!media.promise) {
                media.reject("Unload media");
            } else {
                media.destroy();
            }
        });

        mediaObjects = {};
    }

    /**
    * Beendet alle Medien-Wiedergaben
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService
    */
    function stopAll() {
        if (!!currentMedia) currentMedia.stop();
    }


    /**
    * Medien-Model für die Steuerung der Medien-Wiedergabe
    * @class Media
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService
    */
    var Media = function (obj) {
        this.id = obj.id;
        this.subtitle = obj.subtitle;
        this.src = v3sContentMediaPath + obj.file;

        this.media = null;
        this.mediaSource = null;
        this.updateTimer = null;
        this.videoPlayback = null;
        this.endedCallbacks = [];
        this.errorCallbacks = [];
        this.updateCallbacks = [];

        if (!!obj.audio) {
            this.audio = obj.audio;
        } else if (!!obj.video) {
            this.video = obj.video;
            this.showVideoControls();
        }

        this.deferredMetadata = $q.defer();
    };

    /**
    * Bereitet die Medien-Wiedergabe vor
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService.Media
    */
    Media.prototype.load = function () {
        if (!currentMedia || currentMedia != this) {
            if (!!currentMedia) {
                currentMedia.stop();
            }
            currentMedia = this;

            if (!!this.audio) {
                if (!oneMediaObjectMode) {
                    cteateAudioObject();
                }

                this.audio.append(singleAudio);
                this.media = singleAudio;
                this.mediaSource = singleAudioSrc;
            } else if (!!this.video) {
                if (!oneMediaObjectMode) {
                    cteateVideoObject();
                }

                this.video.append(singleVideo);
                this.media = singleVideo;
                this.mediaSource = singleVideoSrc;
            }

            if (!!this.media) {
                var self = this;

                this.media.bind("playing", function (evt) {
                    playbackStatus = "playing";
                })
                this.media.bind("pause", function (evt) {
                    playbackStatus = "pause";
                })

                this.media.bind("error", function (e) {
                    v3sLog.warn("Playback error: ");
                    v3sLog.warn(e);
                    angular.forEach(self.errorCallbacks, function (callback) {
                        callback();
                    });
                    playbackStatus = "error";
                });

                this.media.bind("ended", function () {
                    angular.forEach(self.endedCallbacks, function (callback) {
                        callback();
                    });
                    self.stop();
                    playbackStatus = "ended";
                });

                this.media.bind("loadedmetadata", function () {
                    if (isFinite(self.media[0].duration)) {
                        self.deferredMetadata.resolve(self.media[0].duration);
                    } else {
                        self.deferredMetadata.resolve(0);
                    }
                });

                this.updateTimer = $interval(function () {
                    if (!self.media[0].paused) {
                        angular.forEach(self.updateCallbacks, function (callback) {
                            callback(self.media[0].currentTime);
                        });
                    }
                }, 100);

                if (!!this.videoPlayback) {
                    this.media.attr("controls", "controls");
                    this.media.attr("controlsList", "nodownload");
                    this.media.attr("data-clickable", "true");
                }

                //Verhindert, das Videos auf IOS-Geräten immer im Fullscreen gespielt werden
                this.media.attr("playsinline", "");

                this.mediaSource[0].type = getMediaType(this.src);
                this.mediaSource[0].src = this.src;
                this.media[0].load();
                this.media[0].muted = isMuted;

                return true;
            }
        }
        return false;
    };

    /**
    * Räumt die Medien-Wiedergabe auf
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService.Media
    */
    Media.prototype.unload = function () {
        if (!!this.media) {
            this.media.unbind();
            $interval.cancel(this.updateTimer);

            this.media.removeAttr("controls");
            this.media.removeAttr("data-clickable");

            this.mediaSource[0].src = "";
            this.mediaSource[0].type = "";

            this.media.remove();
        }
        currentMedia = null;
    };

    /**
    * Startet die Medien-Wiedergabe
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService.Media
    */
    Media.prototype.play = function (position) {

        if (this.load()) {
            var self = this;
            this.media.one("canplay", function () {
                self.seek(position);
            });
        } else {
            this.seek(position);
        }

        this.media[0].play();
        if (showSubtitles && v3sSubtitleService) v3sSubtitleService.show(this.subtitle, this);
    };

    /**
    * Ändert oder gibt die Position der Medien-Wiedergabe zurück
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService.Media
    */
    Media.prototype.seek = function (position) {
        try {
            if (isFinite(position) && this.media[0].currentTime != position) {
                this.media[0].currentTime = position;
            } else {
                return this.media[0].currentTime;
            }
        } catch (e) {
            v3sLog.warn("Exception: ", false, e);
        }
    };

    /**
    * Aktiviert/deaktiviert Benutzer-Video-Wiedergabe
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService.Media
    */
    Media.prototype.showVideoControls = function (visible) {
        if (!!this.video) {
            var self = this;
            if (visible == false && !!this.videoPlayback) {
                this.video.removeClass("video-play-btn");
                this.video.off('click', this.videoPlayback);
                this.videoPlayback = null;
            } else if (!this.videoPlayback) {
                this.videoPlayback = function () {
                    if (currentMedia != self) {
                        self.play();
                    }
                };
                this.video.addClass("video-play-btn");
                this.video.on('click', this.videoPlayback);
            }
        }
    };

    /**
    * Beendet die Medien-Wiedergabe
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService.Media
    */
    Media.prototype.stop = function () {
        if (!!this.media) {

            this.media[0].pause();
            this.seek(0);

            this.unload();
            if (v3sSubtitleService) v3sSubtitleService.hide();
        }
    };

    /**
    * Pausiert die Medien-Wiedergabe
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService.Media
    */
    Media.prototype.pause = function () {
        if (!!this.media) {
            this.media[0].pause();
        }
    };

    /**
    * Gibt Wiedergabedauer des Medienobjekts zurück
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService.Media
    * @return eine Promise, die aufgelöst wird, wenn die Metadaten geladen sind.
    */
    Media.prototype.getDuration = function () {
        return this.deferredMetadata.promise;
    };



    /**
    * Legt die Callback-Funktion fest, die bei Wiedergabe-Ende aufgerufen wird
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService.Media
    */
    Media.prototype.onEnded = function (callback) {
        this.endedCallbacks.push(callback);
    };

    /**
    * Legt die Callback-Funktion fest, die bei Wiedergabe-Fehler aufgerufen wird
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService.Media
    */
    Media.prototype.onError = function (callback) {
        this.errorCallbacks.push(callback);
    };

    /**
    * Legt die Callback-Funktion fest, die bei Wiedergabe aufgerufen wird
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService.Media
    */
    Media.prototype.onTimeUpdate = function (callback) {
        this.updateCallbacks.push(callback);
    };

    /**
    * Räumt Medienobjekt auf
    * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService.Media
    */
    Media.prototype.destroy = function () {
        this.stop();
        this.audio = null;
        this.video = null;
        if (!!this.deferredMetadata) {
            this.deferredMetadata.reject();
        }
    };


    /**
     * Speichert den Wiedergabestatus
     * @memberOf v3sWbtPlayerApp:page:media.service_v3sMediaService.Media
    */
    Media.prototype.isPlaying = function () {
        if (!this.media) return;
        return (playbackStatus == "playing") ? true : false;
    };


    return {
        mute: mute,
        showSubtitle : showSubtitle,
        isMediaServiceReady: isMediaServiceReady,
        prepareMedia: prepareMedia,
        createMedia: createMedia,
        getMedia: getMedia,
        getCurrentMedia: getCurrentMedia,
        stopAll: stopAll,
        destroy: destroy
    }
}]);